import React, { forwardRef, memo, useRef, useState, useEffect, useLayoutEffect } from 'react';
import DateInput from '../DateInput.jsx';


const DateTimeCellEditor = memo(forwardRef(({value, format, onValueChange, eventKey, altInput= false, altFormat='YYYY-MM-DD'}, ref) => {
  const [isInDialog, setIsInDialog] = useState(null);
  const refContainer = useRef(null);
  const [date, setDate] = useState(value);

  const isLeftOrRight = (eventKey) => {
    return ['ArrowLeft', 'ArrowRight'].indexOf(eventKey) > -1;
  };

  const isCharNumeric = (charStr) => {
    return !!/\d/.test(charStr);
  };

  const isNumericKey = (eventKey) => {
    return isCharNumeric(eventKey);
  };

  const isBackspace = (eventKey) => {
    return eventKey === 'Backspace';
  };

  const updateValue = (val) => {
    setDate(val);
    onValueChange(val === '' ? null : val);
  };

  useEffect(() => {
    let startValue;

    if (isBackspace(eventKey) || isLeftOrRight(eventKey)) {
      startValue = '';
    } else {
      startValue = value;
    }

    if (startValue == null) {
      startValue = '';
    }

    if (!isNumericKey(eventKey)) {
      updateValue(startValue);
    }

    refContainer.current.focus();
  }, []);

  useLayoutEffect(() => {
    const el = refContainer.current
    setIsInDialog(!!el?.closest('.dialog-input-wrapper'))
  }, [])

  return (
      <div ref={refContainer}>
        {isInDialog !== null && <DateInput 
          defaultValue={date}
          onChange={updateValue}
          pickerOptions={{inline: !isInDialog, format: format, useCurrent: false, altInput: altInput, altFormat: altFormat}}
        />}
      </div>
  );
}));

export default DateTimeCellEditor;